// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Reset & Base ===== */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.search-wrap {
    background: #f5f7fb;
    color: #333;
    min-height: 100vh;
}

/* ===== Header ===== */
.search-header {
    background: #fff;
    padding: 18px 14px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.logo {
    /* width: 100%; */
    font-size: 24px;
    font-weight: 700;
    color: #1C6DD0;
    padding: 0px 0px 8px;
}

.search-bar {
    flex: 1 1;
    margin-left: 20px;
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.search-bar input {
    border: none;
    padding: 10px 15px;
    flex: 1 1;
    font-size: 15px;
    outline: none;
}

.search-bar button {
    background: #1C6DD0;
    border: none;
    color: #fff;
    padding: 10px 18px;
    cursor: pointer;
    font-weight: 600;
}

.filter-btn {
    margin-left: 10px;
    background: #E9F1FB;
    border: none;
    color: #1C6DD0;
    padding: 10px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
}

/* ===== Popular Tags ===== */
.popular-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding-top: 5px;
}

.tag {
    background: #f0f4f9;
    color: #1C6DD0;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: .2s;
    border: none;
}

.tag:hover {
    background: #d9e8fa;
}

/* ===== Summary Bar ===== */
.summary {
    margin: 25px 10px 10px;
    max-width: 1200px;
    font-size: 15px;
    color: #555;
}

/* ===== Search Section ===== */
.search-section {
    margin: 30px 0;
    padding: 0 20px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.search-section-title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
    margin-bottom: 15px;
    padding-left: 5px;
}

.card-list-horizontal {
    display: flex;
    gap: 15px;
    overflow-x: auto;
    padding: 5px 0 20px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
}

.card-list-horizontal::-webkit-scrollbar {
    height: 6px;
}

.card-list-horizontal::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.card-list-horizontal::-webkit-scrollbar-thumb {
    background: #1C6DD0;
    border-radius: 10px;
}

.card-small {
    min-width: 200px;
    max-width: 200px;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
    transition: .25s;
    scroll-snap-align: start;
}

.card-small:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-small .badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #FFB800;
    color: #fff;
    font-size: 10px;
    padding: 3px 6px;
    border-radius: 4px;
    font-weight: 600;
}

.card-small h4 {
    font-size: 16px;
    color: #1C6DD0;
    margin-bottom: 8px;
    font-weight: 600;
    line-height: 1.3;
}

.card-small-org {
    font-size: 12px;
    color: #777;
    margin-bottom: 4px;
    line-height: 1.4;
}

.card-small-field {
    font-size: 11px;
    color: #999;
    margin-bottom: 0;
    line-height: 1.4;
}

/* ===== Card List ===== */
.card-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px 30px;
    /* padding: 0 20px 110px; */
}

.card {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
    transition: .25s;
}

.card:hover {
    transform: translateY(-4px);
}

.badge {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #FFB800;
    color: #fff;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 6px;
    font-weight: 600;
}

.card h3 {
    font-size: 18px;
    color: #1C6DD0;
    margin-bottom: 8px;
}

.card p {
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
    line-height: 1.4;
}

.btn-detail {
    margin-top: 10px;
    display: inline-block;
    background: #1C6DD0;
    color: #fff;
    padding: 8px 14px;
    border-radius: 6px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    transition: .2s;
}

.btn-detail:hover {
    background: #1558A8;
}

/* ===== Filter Modal ===== */
.filter-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.filter-overlay.active {
    display: flex;
}

.filter-modal {
    background: #fff;
    border-radius: 16px;
    padding: 25px 30px;
    width: 90%;
    max-width: 520px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    animation: fadeIn .25s ease;
}

.filter-modal h2 {
    font-size: 20px;
    margin-bottom: 15px;
    color: #1C6DD0;
}

.filter-section {
    margin-bottom: 18px;
}

.filter-section label {
    display: block;
    font-weight: 600;
    margin-bottom: 6px;
    color: #333;
}

.filter-section input[type="text"] {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 15px;
}

.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag-list .tag {
    background: #f2f6fb;
    color: #1C6DD0;
}

.tag-list .tag.active,
.tag-list .tag:hover {
    background: #1C6DD0;
    color: #fff;
}

.toggle-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.toggle-group label {
    background: #f2f6fb;
    border-radius: 8px;
    padding: 6px 10px;
    cursor: pointer;
    color: #333;
    font-size: 14px;
    transition: .2s;
}

.toggle-group input {
    margin-right: 6px;
}

.toggle-group label:hover {
    background: #e2ecfb;
}

.year-slider {
    width: 100%;
    margin-top: 6px;
}

.range-value {
    font-size: 13px;
    color: #555;
    text-align: right;
    margin-top: 4px;
}

.filter-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
}

.btn-reset,
.btn-apply {
    flex: 1 1;
    padding: 10px 0;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: .25s;
}

.btn-reset {
    background: #f0f4f9;
    color: #1C6DD0;
    border: none;
    margin-right: 10px;
}

.btn-apply {
    background: #1C6DD0;
    color: #fff;
    border: none;
}

.btn-apply:hover {
    background: #1558A8;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===== 안내 모달 (탐정법인홍익 모바일 신분증) ===== */
.info-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.info-modal {
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    animation: fadeIn 0.3s ease-out;
}

.info-modal-header {
    background: #FFD700;
    padding: 20px;
    border-radius: 12px 12px 0 0;
}

.info-modal-logo-container {
    display: flex;
    align-items: center;
    gap: 15px;
}

.info-modal-logo-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #4CAF50;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    flex-shrink: 0;
}

.info-modal-title-group {
    flex: 1 1;
}

.info-modal-title-kr {
    font-size: 20px;
    font-weight: 700;
    color: #000;
    margin-bottom: 4px;
}

.info-modal-title-en {
    font-size: 12px;
    font-weight: 600;
    color: #000;
    letter-spacing: 0.5px;
}

.info-modal-body {
    padding: 0;
    background: #fff;
}

.info-modal-content {
    color: #333;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 0;
    padding: 30px 20px 20px 20px;
    background: #f8f9fa;
    min-height: 300px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.info-modal-content p {
    margin: 0;
    margin-bottom: 8px;
}

/* 구분선 */
.info-modal-divider {
    height: 1px;
    background: linear-gradient(to right, transparent, #e0e0e0 20%, #e0e0e0 80%, transparent);
    margin: 0;
}

/* 신청 안내 섹션 */
.info-modal-apply-section {
    padding-top: 20px;
    background: #fff;
    margin: 0;
    padding: 12px 20px;
}

.info-modal-link {
    text-align: center;
    font-size: 15px;
    color: #5f5f5f;
    line-height: 1.6;
    margin-top: 0;
}

.info-modal-footer {
    padding: 0 20px 20px;
    background: #fff;
    border-radius: 0 0 12px 12px;
}

.info-modal-btn {
    width: 100%;
    background: #1C6DD0;
    color: #fff;
    border: 1px solid #0d4a8a;
    border-radius: 8px;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.info-modal-btn:hover {
    background: #1558A8;
}

.info-modal-btn:active {
    background: #0d4a8a;
}

/* ===== Responsive ===== */
@media (max-width:600px) {
    .header-top {
        flex-direction: column;
        gap: 10px;
    }

    .search-bar {
        width: 100%;
        margin: 0;
    }

    .filter-btn {
        width: 100%;
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/search.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAO;IACP,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;IAEI,SAAO;IACP,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA,QAAQ;AACR;IACI,WAAW;IACX,yFAAyF;IACzF,SAAS;AACb;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,SAAS;IACb;AACJ","sourcesContent":["/* ===== Reset & Base ===== */\r\n* {\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.search-wrap {\r\n    background: #f5f7fb;\r\n    color: #333;\r\n    min-height: 100vh;\r\n}\r\n\r\n/* ===== Header ===== */\r\n.search-header {\r\n    background: #fff;\r\n    padding: 18px 14px;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.header-top {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: relative;\r\n}\r\n\r\n.logo {\r\n    /* width: 100%; */\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #1C6DD0;\r\n    padding: 0px 0px 8px;\r\n}\r\n\r\n.search-bar {\r\n    flex: 1;\r\n    margin-left: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #fff;\r\n}\r\n\r\n.search-bar input {\r\n    border: none;\r\n    padding: 10px 15px;\r\n    flex: 1;\r\n    font-size: 15px;\r\n    outline: none;\r\n}\r\n\r\n.search-bar button {\r\n    background: #1C6DD0;\r\n    border: none;\r\n    color: #fff;\r\n    padding: 10px 18px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}\r\n\r\n.filter-btn {\r\n    margin-left: 10px;\r\n    background: #E9F1FB;\r\n    border: none;\r\n    color: #1C6DD0;\r\n    padding: 10px 16px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}\r\n\r\n/* ===== Popular Tags ===== */\r\n.popular-tags {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    padding-top: 5px;\r\n}\r\n\r\n.tag {\r\n    background: #f0f4f9;\r\n    color: #1C6DD0;\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: .2s;\r\n    border: none;\r\n}\r\n\r\n.tag:hover {\r\n    background: #d9e8fa;\r\n}\r\n\r\n/* ===== Summary Bar ===== */\r\n.summary {\r\n    margin: 25px 10px 10px;\r\n    max-width: 1200px;\r\n    font-size: 15px;\r\n    color: #555;\r\n}\r\n\r\n/* ===== Search Section ===== */\r\n.search-section {\r\n    margin: 30px 0;\r\n    padding: 0 20px;\r\n    max-width: 1200px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.search-section-title {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    color: #333;\r\n    margin-bottom: 15px;\r\n    padding-left: 5px;\r\n}\r\n\r\n.card-list-horizontal {\r\n    display: flex;\r\n    gap: 15px;\r\n    overflow-x: auto;\r\n    padding: 5px 0 20px;\r\n    scroll-snap-type: x mandatory;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.card-list-horizontal::-webkit-scrollbar {\r\n    height: 6px;\r\n}\r\n\r\n.card-list-horizontal::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n}\r\n\r\n.card-list-horizontal::-webkit-scrollbar-thumb {\r\n    background: #1C6DD0;\r\n    border-radius: 10px;\r\n}\r\n\r\n.card-small {\r\n    min-width: 200px;\r\n    max-width: 200px;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 16px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    position: relative;\r\n    transition: .25s;\r\n    scroll-snap-align: start;\r\n}\r\n\r\n.card-small:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.card-small .badge {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 12px;\r\n    background: #FFB800;\r\n    color: #fff;\r\n    font-size: 10px;\r\n    padding: 3px 6px;\r\n    border-radius: 4px;\r\n    font-weight: 600;\r\n}\r\n\r\n.card-small h4 {\r\n    font-size: 16px;\r\n    color: #1C6DD0;\r\n    margin-bottom: 8px;\r\n    font-weight: 600;\r\n    line-height: 1.3;\r\n}\r\n\r\n.card-small-org {\r\n    font-size: 12px;\r\n    color: #777;\r\n    margin-bottom: 4px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.card-small-field {\r\n    font-size: 11px;\r\n    color: #999;\r\n    margin-bottom: 0;\r\n    line-height: 1.4;\r\n}\r\n\r\n/* ===== Card List ===== */\r\n.card-list {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n    gap: 20px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 0 20px 30px;\r\n    /* padding: 0 20px 110px; */\r\n}\r\n\r\n.card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    position: relative;\r\n    transition: .25s;\r\n}\r\n\r\n.card:hover {\r\n    transform: translateY(-4px);\r\n}\r\n\r\n.badge {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 15px;\r\n    background: #FFB800;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    padding: 4px 8px;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n}\r\n\r\n.card h3 {\r\n    font-size: 18px;\r\n    color: #1C6DD0;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.card p {\r\n    font-size: 14px;\r\n    color: #555;\r\n    margin-bottom: 5px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.btn-detail {\r\n    margin-top: 10px;\r\n    display: inline-block;\r\n    background: #1C6DD0;\r\n    color: #fff;\r\n    padding: 8px 14px;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    transition: .2s;\r\n}\r\n\r\n.btn-detail:hover {\r\n    background: #1558A8;\r\n}\r\n\r\n/* ===== Filter Modal ===== */\r\n.filter-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.35);\r\n    display: none;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 999;\r\n}\r\n\r\n.filter-overlay.active {\r\n    display: flex;\r\n}\r\n\r\n.filter-modal {\r\n    background: #fff;\r\n    border-radius: 16px;\r\n    padding: 25px 30px;\r\n    width: 90%;\r\n    max-width: 520px;\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n    animation: fadeIn .25s ease;\r\n}\r\n\r\n.filter-modal h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 15px;\r\n    color: #1C6DD0;\r\n}\r\n\r\n.filter-section {\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.filter-section label {\r\n    display: block;\r\n    font-weight: 600;\r\n    margin-bottom: 6px;\r\n    color: #333;\r\n}\r\n\r\n.filter-section input[type=\"text\"] {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ccc;\r\n    font-size: 15px;\r\n}\r\n\r\n.tag-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n.tag-list .tag {\r\n    background: #f2f6fb;\r\n    color: #1C6DD0;\r\n}\r\n\r\n.tag-list .tag.active,\r\n.tag-list .tag:hover {\r\n    background: #1C6DD0;\r\n    color: #fff;\r\n}\r\n\r\n.toggle-group {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n}\r\n\r\n.toggle-group label {\r\n    background: #f2f6fb;\r\n    border-radius: 8px;\r\n    padding: 6px 10px;\r\n    cursor: pointer;\r\n    color: #333;\r\n    font-size: 14px;\r\n    transition: .2s;\r\n}\r\n\r\n.toggle-group input {\r\n    margin-right: 6px;\r\n}\r\n\r\n.toggle-group label:hover {\r\n    background: #e2ecfb;\r\n}\r\n\r\n.year-slider {\r\n    width: 100%;\r\n    margin-top: 6px;\r\n}\r\n\r\n.range-value {\r\n    font-size: 13px;\r\n    color: #555;\r\n    text-align: right;\r\n    margin-top: 4px;\r\n}\r\n\r\n.filter-actions {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 25px;\r\n}\r\n\r\n.btn-reset,\r\n.btn-apply {\r\n    flex: 1;\r\n    padding: 10px 0;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: .25s;\r\n}\r\n\r\n.btn-reset {\r\n    background: #f0f4f9;\r\n    color: #1C6DD0;\r\n    border: none;\r\n    margin-right: 10px;\r\n}\r\n\r\n.btn-apply {\r\n    background: #1C6DD0;\r\n    color: #fff;\r\n    border: none;\r\n}\r\n\r\n.btn-apply:hover {\r\n    background: #1558A8;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(15px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* ===== 안내 모달 (탐정법인홍익 모바일 신분증) ===== */\r\n.info-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    padding: 20px;\r\n}\r\n\r\n.info-modal {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    width: 100%;\r\n    max-width: 400px;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n    animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.info-modal-header {\r\n    background: #FFD700;\r\n    padding: 20px;\r\n    border-radius: 12px 12px 0 0;\r\n}\r\n\r\n.info-modal-logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n}\r\n\r\n.info-modal-logo-circle {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n    background: #4CAF50;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.info-modal-title-group {\r\n    flex: 1;\r\n}\r\n\r\n.info-modal-title-kr {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    color: #000;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.info-modal-title-en {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.info-modal-body {\r\n    padding: 0;\r\n    background: #fff;\r\n}\r\n\r\n.info-modal-content {\r\n    color: #333;\r\n    font-size: 16px;\r\n    line-height: 1.8;\r\n    margin-bottom: 0;\r\n    padding: 30px 20px 20px 20px;\r\n    background: #f8f9fa;\r\n    min-height: 300px;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.info-modal-content p {\r\n    margin: 0;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n/* 구분선 */\r\n.info-modal-divider {\r\n    height: 1px;\r\n    background: linear-gradient(to right, transparent, #e0e0e0 20%, #e0e0e0 80%, transparent);\r\n    margin: 0;\r\n}\r\n\r\n/* 신청 안내 섹션 */\r\n.info-modal-apply-section {\r\n    padding-top: 20px;\r\n    background: #fff;\r\n    margin: 0;\r\n    padding: 12px 20px;\r\n}\r\n\r\n.info-modal-link {\r\n    text-align: center;\r\n    font-size: 15px;\r\n    color: #5f5f5f;\r\n    line-height: 1.6;\r\n    margin-top: 0;\r\n}\r\n\r\n.info-modal-footer {\r\n    padding: 0 20px 20px;\r\n    background: #fff;\r\n    border-radius: 0 0 12px 12px;\r\n}\r\n\r\n.info-modal-btn {\r\n    width: 100%;\r\n    background: #1C6DD0;\r\n    color: #fff;\r\n    border: 1px solid #0d4a8a;\r\n    border-radius: 8px;\r\n    padding: 12px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.info-modal-btn:hover {\r\n    background: #1558A8;\r\n}\r\n\r\n.info-modal-btn:active {\r\n    background: #0d4a8a;\r\n}\r\n\r\n/* ===== Responsive ===== */\r\n@media (max-width:600px) {\r\n    .header-top {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .search-bar {\r\n        width: 100%;\r\n        margin: 0;\r\n    }\r\n\r\n    .filter-btn {\r\n        width: 100%;\r\n        margin: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
